<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted font-13 mb-4"></p>
                        <div class="row mb-md-2">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions">
                                        </b-form-select>&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ml-2">
                                        </b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    ref="activeProducts"
                                    :items="activeProductsData"
                                    :busy.sync="isBusy"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn">

                                <template v-slot:cell(id)="row">
                                    <a href="javascript: void(0);"
                                       class="text-body font-weight-bold"
                                    >{{ row.item.id }}</a>
                                </template>

                                <template v-slot:cell(name)="row">
                                    {{row.item.product.name}}
                                </template>

                                <template v-slot:cell(discount)="row">
                                    {{ discountValue(row.item.product.sku) }}%
                                </template>

                                <template v-slot:cell(action)="row">
                                    <b-button :id="row.item.id" variant="primary"
                                              type="button" class="btn btn-blue" @click="checkDiscount(row.item)">
                                        <i class="mdi mdi-eye"></i>
                                    </b-button>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="rows"
                                                :per-page="perPage"
                                                @input =" pageChange(currentPage);">
                                        </b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="remark-modal"
                 ref="remark" size="lg" title="Discount in %" title-class="font-18">

            <div class="form-group">
                <input id="discountAmount"
                      v-model="discount" type="number" class="form-control"/>
            </div>
            <div class="form-group">
                <b-button id="submit-discount" variant="primary"
                          type="button" class="btn btn-blue" @click="defineDiscount" >
                    Submit
                </b-button>
            </div>
        </b-modal>
    </Layout>
</template>

<script>
  import appConfig from '@src/app.config'
  import Layout from '@layouts/main'
  import PageHeader from '@components/page-header'

  import { companiesMethods } from '@state/helpers'


  /**
   * Advanced table component
   */
  export default {
    page: {
      title: 'Assign Discounts',
      meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
      return {
        products: [],
        discounts: [],
        title: 'Assign Discounts',
        items: [
          {
            text: '99Gift',
            href: '/',
          },
          {
            text: 'Companies',
            href: '/',
          },
          {
            text: this.$route.params.company || '',
            href: '/',
          },
          {
            text: 'Assign Discounts',
            active: true,
          },
        ],
        isBusy: false,
        discount: null,
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: 'company_products.id',
        sortDesc: false,
        selectedRow: null,
        fields: [
          { key: 'company_products.id', label: 'Id', sortable: true },
          { key: 'name', label: 'Name', sortable: false },
          { key: 'discount', label: 'Discount', sortable: false },
          { key: 'action',  label: 'Action', sortable: false },
        ],
      }
    },
    computed: {
      /**
       * Total no. of records
       */
      rows() {
        return this.totalRows
      },
    },
    mounted() {
      this.id = parseInt(this.$route.params.id)
      this.company = this.$route.params.company

      this.discountList()
    },
    methods: {
      ...companiesMethods,

      async discountList(){

        const discount = {}

        try{
          const { success, message, data: { result }} = await this.discountData(this.id)

          if(!success) throw Error(message)

          result.forEach(each=>{
            discount[each.sku] = each.discount
          })

          this.discounts = discount;
        }
        catch (e){
          this.appToast('Error', e.message || 'Error while operating', 'danger')
        }
      },

      async activeProductsData(context) {

        const { filter, sortBy, sortDesc , perPage, currentPage } = context;

        this.currentPage = currentPage;
        this.rowsPerPage = perPage;

        this.isBusy = true

        try{

          const { success, message, data: { result } } = await this.companyActiveProducts({
            id: this.id,
            filter,
            page: this.currentPage,
            rowsPerPage: this.perPage,
            sortBy,
            descending: sortDesc

          });

          if(!success) throw Error(message)

          this.totalRows = result.totalCount
          this.products =  result.data
        }
        catch (e){

          this.products = []
          this.appToast('Error', e.message || 'Error while operating', 'danger')
        }

        this.isBusy = false
        return this.products;
      },

      async defineDiscount(){

        if(this.discount){

          try{
            const key = this.discountDetail.sku;
            const discountMeta = [{ sku: key, discount: parseInt(this.discount) }]

            const { success, message } = await this.assignDiscount({
              company: this.id,
              products: discountMeta
            })

            if(!success) throw Error(message)

            this.discounts[key] = this.discount;
            this.$refs.activeProducts.refresh();
            this.appToast('Success', 'Discount assigned successfully!', 'success')
          }
          catch (e){
            this.appToast('Error', e.message || 'Error while operating', 'danger')
          }
        }
        else{
          this.appToast('Invalid discount', 'Error a valid discount value!', 'danger')
        }
      },

      discountValue(key){
        return this.discounts[key] || 0.0
      },

      async pageChange(page){
        this.currentPage = page
      },

      checkDiscount(data){
        this.discountDetail = data;
        this.discount = this.discounts[data.sku] || 0.0
        this.$refs.remark.show()
      },

    },
  }
</script>